import { Component, Input, SimpleChanges } from "@angular/core";

@Component({
  selector: "app-kansas-state-form",
  standalone: true,
  imports: [],
  templateUrl: "./kansas-state-form.component.html",
  styleUrl: "./kansas-state-form.component.scss",
})
export class KansasStateFormComponent {
  @Input() policyDetails!: any;

  ngOnChanges(changes: SimpleChanges): void {
    if (changes["policyDetails"]) {
      this.policyDetails = changes["policyDetails"].currentValue?.aul_013_24;
    }
  }
}
